import React from 'react'
import { SideBarHelpMe } from '../side-bar-help-me'
import { SideBarMenu } from '../side-bar-menu'

export const SideBar: React.FC = () => {
  return (
    <div className="hidden md:flex flex-col gap-4 w-56">
      <SideBarMenu />
      <SideBarHelpMe
        className="p-6 bg-gray-100 shadow-sm"
        titleClas="font-bold  text-gray-900"
      />
    </div>
  )
}
